import { render, staticRenderFns } from "./ExportacaoDados.vue?vue&type=template&id=6f8a6fb9&scoped=true"
import script from "./ExportacaoDados.vue?vue&type=script&lang=js"
export * from "./ExportacaoDados.vue?vue&type=script&lang=js"
import style0 from "./ExportacaoDados.vue?vue&type=style&index=0&id=6f8a6fb9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8a6fb9",
  null
  
)

export default component.exports